const Strings = {
    INVESTMENT_STRINGS: {
        growth: {
            title: "Supercharge Your Investment Returns",
            subtitle: "Investing in MFs not only grows your wealth it also unlocks perks you don't get anywhere else.",
            label: "Growth In Last 2 Yrs",
            footnote: "This data is is gathered from historic index fund returns",
        },
        savings: {
            title: "And Unlock Discounts + Zero Cost EMIs",
            subtitle: "Pledge your Mutual Funds and instantly unlock a sweet discount. Same phone, same specs, just lighter on your wallet.",
            label: '',
            footnote: 'footnote',
        },
        common: {
            strikeoffAlt: "strikethrough",
            rupeeSymbol: "₹",
        }
    },
    // strings.ts (create this file in your project, e.g., in a utils or constants folder)
    WhatisComing: {
        sectionTitle: "Discover What's Coming",
        sectionDescription: "We think you deserve the best, so we’re bringing together lifestyle partners that unlock meaningful savings and premium experiences.",
        features: [
            {
                label: "Electronics",
                description: "Get exclusive discounts on premium furniture and home appliances from top brands."
            },
            {
                label: "Flight Tickets",
                description: "Access special fares and premium experiences with leading airlines worldwide."
            },
            {
                label: "Premium Furniture",
                description: "Transform your space with luxury furniture at member-only prices."
            },
            {
                label: "Smart Phone",
                description: "Latest smartphones and gadgets with exclusive member pricing and early access."
            },
            {
                label: "Holidays",
                description: "Luxury accommodations and boutique hotels with premium amenities and rates."
            },
          
            {
                label: "Car",
                description: "Exclusive deals on luxury vehicles, rentals, and automotive services."
            },
            {
                label: "Health and Wellness",
                description: "Premium fitness memberships, wellness retreats, and health services."
            },
            {
                label: "Smart TV",
                description: "Cutting-edge entertainment technology with special member pricing."
            },
        ]
    }
};
export default Strings;